/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type ReviewCard_goal = {
    readonly type: GoalType;
    readonly " $fragmentRefs": FragmentRefs<"GoalStatusField_goal" | "ReviewCardMenu_goal">;
    readonly " $refType": "ReviewCard_goal";
};
export type ReviewCard_goal$data = ReviewCard_goal;
export type ReviewCard_goal$key = {
    readonly " $data"?: ReviewCard_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"ReviewCard_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReviewCard_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalStatusField_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReviewCardMenu_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '5161efcb0fff90ca78b511b11f5c6432';
export default node;
